import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top on every pathname change.
 *
 * Without this, `BrowserRouter` preserves the previous page's scroll offset
 * across navigations. On mobile Safari, if that offset is past the new page's
 * content, the viewport shows a blank area until a touch/scroll event clamps
 * it back into range — surfacing as "the screen goes white until I touch it."
 *
 * Mount once inside <BrowserRouter> (renders nothing).
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}
